export default __webpack_public_path__ + "static/media/regBackGround.07cfc8f8.jpg";